import { appConfig } from '../app.config';

export function classNames(classes) {
    return Object.entries(classes).reduce((acc, item) => {
        const [key, value] = item
        if (value) return [...acc, key]
        return acc
    }, []).join(' ')
}



export function removeAllNonNumericCharacters(str) {
    var strNumeric = str.replace(/\D/g, '');
    return strNumeric;
}

export function isValidPhoneNumberSpecified(phonenumber) {
    if (!phonenumber) {
        return false;
    }
    phonenumber = removeAllNonNumericCharacters(phonenumber);
    var isValid = phonenumber.length === 10 || (phonenumber.length === 11 && phonenumber.charAt(0) === '1');
    return isValid;
}

export function normalizeToUsPlusOnePhone(input) {
    if (!input || typeof input !== 'string') {
        return '';
    }
    const digits = removeAllNonNumericCharacters(input);
    if (digits.length === 10) {
        return '+1' + digits;
    }
    if (digits.length === 11 && digits.charAt(0) === '1') {
        return '+1' + digits.slice(1);
    }
    return '';
}

export function isValidUsPlusOnePhone(input) {
    const normalized = normalizeToUsPlusOnePhone(input);
    return /^\+1\d{10}$/.test(normalized);
}


export function checkRequiredInvalid(model, isSubmitted) {
    if (!isSubmitted) {
        return false;
    }
    let hasError = !model.value || (!!model.value.trim && !model.value.trim());
    model.errors['required'] = hasError;
    return hasError;
}

export function checkEmail (model, isSubmitted) {
    if (!isSubmitted) {
        return false;
    }
    let email = model.value;
    let hasError = !/^[_a-zA-Z`'0-9-+]+(\.[_a-zA-Z`'0-9-+]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,})$/.test(email);
    model.errors['email'] = hasError;
    return hasError;
}

export function checkPhoneInvalid (model, isSubmitted) {
    if (!isSubmitted) {
        return false;
    }
    let hasError = !isValidPhoneNumberSpecified(model.value);
    model.errors['phone'] = hasError;
    return hasError;
}

export function checkUsPlusOnePhoneInvalid(model, isSubmitted) {
    if (!isSubmitted) {
        return false;
    }
    const hasError = !isValidUsPlusOnePhone(model.value);
    model.errors['phone'] = hasError;
    return hasError;
}

export function checkCreditCard(model) {
  let hasError = false;
  hasError = !/^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/.test(model.cardNumber);
  model.errors['card'] = hasError;
  return hasError;
}

export function checkZip(model) {
  const zip = model.value;
  const us = /^\d{5}(?:[-\s]\d{4})?$/.test(zip);
  const canada = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(zip);
  const hasError = !us && !canada;
  model.errors['zip'] = hasError;
  return hasError;
}

export function isMobile() {
    const w = getScreenWidth();
    return (w <= appConfig.mobileMaxWidth);
  }

  export function isSmallTablet() {
    const w = getScreenWidth();
    return (w > appConfig.mobileMaxWidth && w <= appConfig.smallTabletMaxWidth);
  }

  export function isTablet() {
    const w = getScreenWidth();
    return (w > appConfig.smallTabletMaxWidth && w <= appConfig.tabletMaxWidth);
  }

  export function isMobileOrSmallTablet() {
    return isMobile() || isSmallTablet();
  }

  export function isMobileOrTablet() {
    return isMobile() || isTablet();
  }

  export function isDesktop() {
    const w = getScreenWidth();
    return (w > appConfig.tabletMaxWidth);
  }

  export function getScreenWidth() {
    const win = window;
    if (win.visualViewport) {
      return win.visualViewport.width;
    }
    return window.innerWidth;
  }

  export function formatNumber(x) {
    if(x === undefined || x === null) {
        return '';
    }
   const val = Math.round(x*100) / 100; // Round to 2 decimal places
    if (isNaN(val)) {
        return '';
    }
   return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  export function makeid(length) {
    let result           = '';
    const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
}